import React from 'react';
import { useI18n } from 'nordic/i18n';
import { Typography } from '@andes-landings/typography';
import { misc, ui } from '@credits-utils/constants';
import CarouselSnapped, { CarouselSnappedSlide } from '@andes/carousel-snapped';
import { makeRedirection, trackAction, getSlides } from '@/utils';
import SharedPropsContext from '../../../../../contexts/SharedProps';
import { getCategoriesSectionContent } from '../../content/categoriesSection';
import CategoryItem from './components/CategoryItem';
import Miscelanea from '../Miscelanea';

const { BACKGROUND, DEVICE_TYPE } = misc;
const { TYPOGRAPHY } = ui;

const CategoriesSection = () => {
  const { deviceType, categories, tracks, isWebView, seeCategories, baseUrl, queryParams, links } = React.useContext(SharedPropsContext);

  const { i18n } = useI18n();

  const { title, subtitle, seeAllCategories } = getCategoriesSectionContent({
    i18n,
  });
  const defaultSlidesPerView = deviceType === DEVICE_TYPE.DESKTOP ? 10 : 4;

  const slides = getSlides([], categories, defaultSlidesPerView);

  const showPagination = deviceType === DEVICE_TYPE.MOBILE || categories.length > 10;

  const trackInfoMelidata = {
    ...tracks.melidata.events.buyersPage.categoriesSection.goToSpecificCategory,
    event_data: {
      category_id: '0',
    },
  };

  const handleClick = () => {
    trackAction({
      melidata: trackInfoMelidata,
    });

    makeRedirection({
      callback: isWebView ? seeCategories : `${baseUrl}${links.allCategories}?${queryParams ?? ''}`,
      isWebView,
    });
  };
  return (
    <section className="categories-section">
      <Miscelanea />
      <Typography
        className="categories-section__title"
        component={TYPOGRAPHY.COMPONENT.H1}
        type={TYPOGRAPHY.TYPE.TITLE}
        size={TYPOGRAPHY.SIZE.XL}
        color={TYPOGRAPHY.COLOR.PRIMARY}
      >
        {title}
      </Typography>
      <h2 className="categories-section__subtitle">{subtitle}</h2>

      <div className="categories-section__carousel">
        <div className="categories-section__carousel-content">
          <CarouselSnapped
            srLabel="Categories Logos"
            pagination={
              showPagination
                ? {
                  mode: BACKGROUND.LIGHT,
                }
                : false
            }
            scroll="hidden"
            arrows={deviceType === DEVICE_TYPE.DESKTOP}
          >
            {slides.map((slide) => {
              const slideKey = `slide-${slide
                .map((category) => category.id)
                .join('-')}`;
              return (
                <CarouselSnappedSlide key={slideKey}>
                  <div className="categories-section__slide">
                    <div className="categories-section__slide-content">
                      {slide.map((category) => (
                        <CategoryItem
                          key={`category-${category.id}`}
                          category={category}
                        />
                      ))}
                    </div>
                  </div>
                </CarouselSnappedSlide>
              );
            })}
          </CarouselSnapped>
        </div>
      </div>
      <Typography
        className="categories-section__link"
        component={TYPOGRAPHY.COMPONENT.A}
        onClick={handleClick}
      >
        {seeAllCategories}
      </Typography>
    </section>
  );
};

export default CategoriesSection;
